import { createAction, props } from '@ngrx/store';
import { AutoMatchSignalRequirementsResponseDto } from 'src/app/compliance/models/automatch-signal-requirements-response.model';

export const autoMatchResponseSuccess = createAction(
    '[COMPLIANCE REPORT] Automatch Signal R Response Success',
    props<{ data: AutoMatchSignalRequirementsResponseDto }>()
);

export const autoMatchResponseFailure = createAction(
    '[COMPLIANCE REPORT] Automatch Signal R Response Failure',
    props<{ error: unknown }>()
);

export const markAsReviewed = createAction(
    '[Compliance Report Component - Legacy] Mark As Reviewed',
    props<{ contractId: number }>()
);

export const markAsReviewedSuccess = createAction(
    '[Compliance Report Effects - Legacy] Mark As Reviewed Success',
    props<{ contractId: number }>()
);

export const markAsReviewedFailure = createAction(
    '[Compliance Report Effects - Legacy] Mark As Reviewed Fail',
    props<{ error: any }>()
);
